function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from 'react';

var _ref =
/*#__PURE__*/
React.createElement("path", {
  d: "M549.36 355V173H285.36L285 355H549.36Z",
  className: "primary-lightened-1"
});

var _ref2 =
/*#__PURE__*/
React.createElement("path", {
  d: "M515.36 354.89V389.94L480.42 355L515.36 354.89Z",
  className: "primary"
});

var _ref3 =
/*#__PURE__*/
React.createElement("path", {
  d: "M549.36 355V173H332.73L514.73 355H549.36Z",
  className: "primary"
});

var _ref4 =
/*#__PURE__*/
React.createElement("path", {
  d: "M230.902 224.83L229.588 225L219.146 184.8L220.416 184.41C230.127 181.07 240.978 187.2 243.91 198.36C246.843 209.52 240.612 221.49 230.902 224.83Z",
  className: "secondary"
});

var _ref5 =
/*#__PURE__*/
React.createElement("path", {
  d: "M114.982 312.89L127.677 361.71C128.132 363.379 128.294 365.135 128.153 366.877C128.013 368.619 127.573 370.311 126.859 371.855C126.145 373.4 125.171 374.766 123.994 375.875C122.817 376.984 121.46 377.813 120.001 378.314C118.543 378.815 117.013 378.978 115.5 378.795C113.986 378.611 112.52 378.083 111.185 377.243C109.85 376.403 108.674 375.266 107.724 373.899C106.775 372.532 106.071 370.962 105.654 369.28L99.9021 347.18L114.982 312.89Z",
  className: "secondary-darkened-1"
});

var _ref6 =
/*#__PURE__*/
React.createElement("path", {
  d: "M68.7771 227.45L69.9865 228.76L82.2468 275.19L81.5942 276.72L59.832 275.8L51 241.84L68.7771 227.45Z",
  className: "secondary"
});

var _ref7 =
/*#__PURE__*/
React.createElement("path", {
  d: "M201.778 115L246.66 287.57L129.67 279.68L200.055 116.89L201.778 115Z",
  className: "secondary-lightened-1"
});

var _ref8 =
/*#__PURE__*/
React.createElement("path", {
  d: "M81.4549 276.21L100.346 348.85L130.731 278.99L81.4549 276.21Z",
  className: "secondary"
});

var _ref9 =
/*#__PURE__*/
React.createElement("path", {
  d: "M201.778 115L130.418 279.72L81.5942 276.72L68.777 227.45L201.778 115Z",
  className: "secondary-darkened-1"
});

var _ref10 =
/*#__PURE__*/
React.createElement("path", {
  d: "M235.342 123.905L236.968 110",
  stroke: "#39473F",
  strokeWidth: 6,
  strokeMiterlimit: 10
});

var _ref11 =
/*#__PURE__*/
React.createElement("path", {
  d: "M292.651 153.349L304.68 144.718",
  stroke: "#39473F",
  strokeWidth: 6,
  strokeMiterlimit: 10
});

var _ref12 =
/*#__PURE__*/
React.createElement("path", {
  d: "M310.443 210.21L325.724 211.997",
  stroke: "#39473F",
  strokeWidth: 6,
  strokeMiterlimit: 10
});

var _ref13 =
/*#__PURE__*/
React.createElement("path", {
  d: "M280.09 260.788L289.804 271.961",
  stroke: "#222B26",
  strokeWidth: 6,
  strokeMiterlimit: 10
});

var _ref14 =
/*#__PURE__*/
React.createElement("path", {
  d: "M479.555 234.073L440.845 246.155L405.939 275.614L394.976 292.918L355 323.332L372.932 288.329L376.966 271.888L365.554 269.204L382 252.423L407.953 240.929L428.763 227.342L435.251 216.843L439.73 210.129L442.634 207L462.999 215.728L458.86 222.996L446.213 229.305L479.555 234.073Z",
  fill: "white"
});

var _ref15 =
/*#__PURE__*/
React.createElement("path", {
  d: "M439.73 210.129L435.251 216.843L416.006 227.14L389.833 224.9L417.966 212.369L439.73 210.129Z",
  fill: "#E5E5E5"
});

var _ref16 =
/*#__PURE__*/
React.createElement("path", {
  d: "M376.966 271.888L381.999 252.423L365.554 269.204L376.966 271.888Z",
  fill: "#E5E5E5"
});

var SvgComponent = function SvgComponent(props) {
  return React.createElement("svg", _extends({
    width: 600,
    height: 500,
    viewBox: "0 0 600 500",
    fill: "none"
  }, props), _ref, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13, _ref14, _ref15, _ref16);
};

export default __webpack_public_path__ + "static/media/text_alert.b45a8d33.svg";
export { SvgComponent as ReactComponent };